import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuth } from "./hrmsNotifications";
import Apis from "../../utils/apis";

export const projectsList = createApi({
  reducerPath: "projectList",
  baseQuery: baseQueryWithAuth,
  tagTypes: ["Projects"],
  endpoints: (builder) => ({
    getProjectsData: builder.query({
      query: ({
        page = 1,
        limit,
        type,
        status,
        individual,
        search,
        pagination = true,
        srManager,
        manager,
        assistantManager,
        teamLead,
        agent,
        startDate,
        endDate,
        skipType,
      }) => ({
        url: `${Apis.project}`,
        params: {
          page,
          limit,
          type,
          status,
          individual,
          search,
          pagination,
          srManager,
          manager,
          assistantManager,
          teamLead,
          agent,
          startDate,
          endDate,
          skipType,
        },
      }),
      providesTags: ["Projects"],
      keepUnusedDataFor: 300,
    }),
  }),
});

export const { useGetProjectsDataQuery } = projectsList;
